
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import * as FileSaver from 'file-saver';
import { ErrorDialogComponent, ConfirmDialogComponent } from 'projects/ais-common/src/public-api';
import { Subject, Subscription } from 'rxjs';
import { RequestZKlienta } from './model/request-z-klienta';
import { StavDokumentu } from './model/stav-dokumentu';
import { StudijneProgramyStavPreJazyk } from './model/studijne-programy-stav-pre-jazyk';
import { StudijnyProgram } from './model/studijny-program';
import { TypZaznamuTextu } from './model/typ-zaznamu-textu';
import { VSKDokument } from './model/vsk-dokument';
import { ZaznamTextu } from './model/zaznam-textu';
import { TranslateService } from '@ngx-translate/core';
import { OkDialogComponent } from 'ais-common';
import { Podprogram } from './model/podprogram';
import { ZaverecnaPraca } from './model/zaverecna-praca';
import { Predmet } from './model/predmet';

@Injectable({
  providedIn: 'root'
})

export class AppStateService {

  readonly DOKUMENT_TEXT_STUDIJNEHO_PROGRAMU_A_PODPROGRAMU = 1;
  readonly DOKUMENT_TEXT_OSOBY = 2;
  readonly DOKUMENT_TEXT_STUDIJNEHO_PODPROGRAMU = 3;

  readonly OPAKOVANA_POLOZKA_PODPROGRAMU = 1;
  readonly SPOLOCNA_POLOZKA_VSETKY_STUD_PROGRAMY = 2;
  readonly POLOZKA_PONUKANA_LEN_PRE_PODPROGRAM = 3;
  readonly POSLEDNA_PRIDANA_POLOZKA_PODPROGRAMU = 4;

  readonly VAZBA_STUPEN_TYP_STUDIA: number = 1;

  readonly ZAVERECNE_PRACE_VEDENE: string = 'ZPV';
  readonly ZAVERECNE_PRACE_OBHAJENE: string = 'ZPO';


  jazykyFormulara: string[] = [];
  jazykFormulara1: string = 'SK';
  jazykFormulara2: string = '';
  jazykFormulara3: string = '';
  vybranyJazykFormulara: string = '';

  dataFetched = new Subject<VSKDokument>();
  typZaznamuTextuDataFetched = new Subject<TypZaznamuTextu[]>();
  zaznamyTextuDataFetched = new Subject<ZaznamTextu[]>();
  zaznamyTextuDataSaved = new Subject<ZaznamTextu[]>();
  zaznamyTextuDataUpdated = new Subject<string>();

  ciselnikJazyk1DataFetched = new Subject<string[]>();
  ciselnikJazyk2DataFetched = new Subject<string[]>();
  ciselnikJazyk3DataFetched = new Subject<string[]>();
  ciselnikyDataFetched = new Subject<string[][]>();
  pocetPripustnychProgramovPodprogramuDataFetched = new Subject<number>();
  studProgramyZRegistraDataFetched = new Subject<StudijnyProgram[]>();
  podprogramyZRegistraDataFetched = new Subject<Podprogram[]>();
  stupneStudiaDataFetched = new Subject<string[]>();
  typyStudiaDataFetched = new Subject<string[]>();
  jazykyPoloziekDokumentuStudProgramuDataFetched = new Subject<string[]>();
  jazykyPoloziekDokumentuPodprogramuDataFetched = new Subject<string[]>();
  pocetSkopirovanychPoloziekDataFetched = new Subject<number>();
  zaverecnePraceDataFetched = new Subject<ZaverecnaPraca[]>();
  akademickeRokyFetched = new Subject<string[]>();
  aktualnyAkRokFetched = new Subject<string>();


  spinnerChanged = new Subject<boolean>();

  idDruhDokumentuDB: number = 0;
  idDruhDokumentu: number = 0;
  idTypDokumentu: number = 0;

  zaznamyTextovZDB: ZaznamTextu[];
  akRok: string = null;
  idStudProgram: number = -1;
  idPodprogram: number = -1;
  idOsoba: number = -1;
  fakulta: string = null;
  haikOdbor = false;

  mapaStavovDokumentovPreIchJazyky: Map<string, StavDokumentu> = new Map();
  mapaUzavretychStavovDokumentovPreIchJazyky: Map<string, StavDokumentu> = new Map();
  mapaZakazanychStavovDokumentovPreIchJazyky: Map<string, StavDokumentu> = new Map();
  // premenna pre podprogram, sp a osobu (nie pre stud. programy podprogramu)
  existujeNevyhovujuciStavDokumentov = false;
  existujeNevyhovujuciStavDokumentovSPPodprogramu = false;
  // existujeNevyhovujuciStavDokPodprogramu = false;
  // TODO: niektoryZDokumentovJeVKoncovomStave - prec
  niektoryZDokumentovJeVKoncovomStave = false;
  // niektoreDokumentySPPodprogramuSuVKoncovomStave = false;
  // jazykyDokumentovSPPodprogramuVKoncovomStave: string[] = [];
  // TODO: studProgramySKoncovymiStavmiDokumentov -  prec
  // studProgramySKoncovymiStavmiDokumentov: string[];
  mapaJazykovDokumentovSKoncovymiStavmiAIchStudijnychProgramov: Map<string, string[]> = new Map();
  // nasledovne pole by sa dalo nahradit nasledujucou mapou, ale zatial to nechame takto
  studProgramySoZakazanymiStavmiDokumentov: string[];
  mapaJazykovDokumentovSoZakazanymiStavmiAIchStudijnychProgramov: Map<string, string[]> = new Map();
  mapaStudProgramovSoZakazanymiStavmiDokumentovAPoliIchJazykov: Map<string, string[]> = new Map();
  jazykyDokumentovVZakazanychStavoch: string[] = [];
  poleNeeditovatelnychStavovString: string[] = [];

  mapaJazykovDokumentovAZakazanychStavov: Map<string, string> = new Map();

  poleJazykovUzavretychStavovKdePouzivatelNechceNovuVerziu: string[] = [];

  mapaIdTypovAMapJazykovAMapPoradiAStudProgramovZaznamov: Map<number, Map<string, Map<number, StudijnyProgram[]>>> = new Map();
  /* v tejto mape (mapaIdTypovAMapJazykovAMapPoradiZaznamovPodprogramu1) budeme
    uchovavat poradia jednotlivych zaznamov podprogramu pre typ a jazyk, kde atribut podprogram === 1.
    Potrebujeme to kvoli tomu, aby sme vedeli, ake poradia maju jednotlive polozky vo formulari
    a mohli nasledne podla tohto poradia pridelit stud. programy danej polozke
  */
  mapaIdTypovAMapJazykovAPoliPoradiZaznamovPodprogram1: Map<number, Map<string,number[]>> = new Map();

  // mapaIdTypovAZaznamovsPodprogramami: Map<number, ZaznamTextu[]> = new Map();
  mapaIdTypovAMapJazykovAZaznamovsPodprogramami: Map<number, Map<string, ZaznamTextu[]>> = new Map();

  mapaIdTypovAMapJazykovAPoradiZaznamov: Map<number, Map<string, number[]>> = new Map();

  // SCSTTypZaznamuTextu - uroven 2
  pouzivatelMozeEditovatPolozkyZUrovneFakulty = true;

  infoOExistenciiDokumentovDataFetched = new Subject<any>();





  // mapy vyuzivane pre uchovanie dat v pripade,

  // ze SCSTTypZaznamuTextu.vazba === 1 (vyberame pre polozku stupne a typy studia)
  // vybraneStupneStudiaKody: string[] = [];
  // mapy vyuzivane pri skupinovych polozkach
  mapaSkupinAMapCastiSkupinyAPoliStupnovStudia: Map<number, Map<number, string[]>> = new Map();
  mapaSkupinAMapCastiSkupinyAPoliTypovStudia: Map<number, Map<number, string[]>> = new Map();

  // mapaSkupinAMapJazykovAMapCastiSkupinyAPoliStupnovStudia: Map<number, Map<string, Map<number, string[]>>> = new Map();
  // mapaSkupinAMapCastiSkupinyAPoliStupnovStudia: Map<number, Map<number, string[]>> = new Map();
  // mapaSkupinAMapJazykovAMapCastiSkupinyAPoliTypovStudia: Map<number, Map<string, Map<number, string[]>>> = new Map();
  // mapaSkupinAMapJazykovAMapCastiSkupinyAPoliTypovStudia: Map<number, Map<string, Map<number, string[]>>> = new Map();

  // neopakovane polozky
  mapaIdTypovZaznamuAStupnovStudia: Map<number, string[]> = new Map();
  mapaIdTypovZaznamuATypovStudia: Map<number, string[]> = new Map();
  // mapaTypovAMapJazykovAStupnovStudia: Map<number, Map<string, string[]>> = new Map();
  // mapaTypovAMapJazykovATypovStudia: Map<number, Map<string, string[]>> = new Map();

  // mapaIdTypovZaznamuAMapJazykovAMapPoradiAStupnovStudia: Map<number, Map<string, Map<number, string[]>>> = new Map();
  // mapaIdTypovZaznamuAMapJazykovAMapPoradiATypovStudia: Map<number, Map<string, Map<number, string[]>>> = new Map();

  //TODO:
  // mapy vyuzivane pri opakovanych (ale neskupinovych) polozkach
  mapaIdTypovZaznamuAMapPoradiAStupnovStudia: Map<number, Map<number, string[]>> = new Map();
  mapaIdTypovZaznamuAMapPoradiATypovStudia: Map<number, Map<number, string[]>> = new Map();

  mapyStupnovATypovStudiaZaznamovNaplnene = new Subject();
  mapyOpakovaniStupnovATypovStudiaZaznamovNaplnene = new Subject();
  mapySkupinStupnovATypovStudiaZaznamovNaplnene = new Subject();
  mapyPreVariant1Naplnene = new Subject();

  zmenaVCombeStupnovStudia = new Subject<string>();
  zmenaVCombeTypovStudia = new Subject<string>();
  zabezpecovanePredmetyFetched = new Subject<Predmet[]>();

  readonly POLOZKA = 4;

  constructor(private http: HttpClient,
    public dialog: MatDialog,
    private translateService: TranslateService) { }

  fetchData(idTypDokumentuTextu: number, idStudProgram: number,
    idOsoba: number, idPodprogram: number,  fakulta: string) {

    // console.log('spinner zapnut!');
    this.spinnerChanged.next(true);

    // console.log('fetchData ' + idTypDokumentuTextu + ' idStudProgram: ' + idStudProgram + ' idPodprogram: ' + idPodprogram
    //   + ' fakulta: ' + fakulta);

    const url = '/ais/rest/apps/vsk/data/'
            + idTypDokumentuTextu +
        '/' + idStudProgram +
        '/' + idOsoba +
        '/' + idPodprogram +
        '/' + fakulta +
        '/' + this.akRok?.replace('/','-')

    // console.log();

    this.http
      .get<VSKDokument>(url)
      .subscribe({
        next: (data) => {
          this.dataFetched.next(data);
          // console.log('fetchedData');
        },
        error: (error: Error) => {
          this.spinnerChanged.next(false);
          // this.openErrorDialog(error.message);
          // console.error('error: ' + JSON.stringify(error));
          // console.log('error.name: ' + error.name)
          // console.log('error.message: ' + error.message)
        }
      });
  }

  // fetchTypZaznamuTextuData(idTypDokumentuTextu: number) {
  //   console.log('fetchTypZaznamuTextuData ' + idTypDokumentuTextu);
  //   this.http
  //     .get<TypZaznamuTextu[]>('/ais/rest/apps/vsk/data/' + idTypDokumentuTextu)
  //     .subscribe(data => {
  //       this.typZaznamuTextuDataFetched.next(data);
  //       console.log('fetchedTypZaznamuTextuData');

  //     });
  // }

  fetchZaznamyTextuData(idOsoby: number, idStudProgram: number, idPodprogram: number,
    idDruhDokumentuTextu: number, idTypDokumentuTextu: number,
    kodJazyk: string) {

    // console.log('spinner zapnut!');
    this.spinnerChanged.next(true);

    // console.log('fetchZaznamyTextuData: ' + idOsoby + ", " + idStudProgram + ", "
    //   + idTypDokumentuTextu + ', ' + kodJazyk);

    let url = '/ais/rest/apps/vsk/zaznamyTextu?';
    url += idOsoby ? 'idOsoby=' + idOsoby : '';
    url += idStudProgram ? '&idStudProgram=' + idStudProgram : '';
    url += idPodprogram ? '&idPodprogram=' + idPodprogram : '';
    url += idDruhDokumentuTextu ? '&idDruhDokumentuTextu=' + idDruhDokumentuTextu : '';
    url += idTypDokumentuTextu ? '&idTypDokumentuTextu=' + idTypDokumentuTextu : '';
    url += kodJazyk ? '&kodJazyk=' + kodJazyk : '';

    this.http
      .get<ZaznamTextu[]>(url)
      .subscribe(zaznamyTextuData => {
        this.zaznamyTextuDataFetched.next(zaznamyTextuData);
        // this.spinnerChanged.next(false);
        // console.log('fetchedZaznamyTextuData: ' + JSON.stringify(zaznamyTextuData));
        // console.log('Pocet ziskanych zaznamov: ' + zaznamyTextuData.length);

      });
  }

  // TODO: zo SAHU servicu "app-state.service.ts" skopirovat osetrenia vynimiek a hlasky
  // ulozenie dat z formulara na server
  saveOrUpdateZaznamyTextuData(zaznamyTextu: ZaznamTextu[], idDruhDokumentu: number,
        idTypDokumentu: number, idStudProgram: number, idPodprogram: number, idOsoba: number,
        kodJazyk: string, stranaFormular: number
      ) {
    // console.log('Zaslanie dat formulara na server: ' + JSON.stringify(zaznamyTextu));
    // console.log('Pocet zaznamov formulara odoslanych na server: ' + zaznamyTextu.length);
    // console.log('saveOrUpdateZaznamyTextuData()');

    const stranaFormulara = stranaFormular ? stranaFormular : -1;
    this.http
      .post<ZaznamTextu[]>('/ais/rest/apps/vsk/saveOrUpdateZaznamyTextu/'
          +  idDruhDokumentu + '/' + idTypDokumentu + '/' + idStudProgram + '/' + idPodprogram + '/'
          + idOsoba + '/' + kodJazyk + '/' + stranaFormulara + '/' + this.akRok?.replace('/', '-'),
        zaznamyTextu)
      .subscribe(data => {
        // console.log('Data su ulozene na servri :)');
        this.zaznamyTextuDataSaved.next(data);
      });
  }

  // ulozFormularAGenerujDokument2(zaznamyTextu: ZaznamTextu[], idDruhDokumentu: number) {
  //   console.log('Zaslanie dat formulara na server + generovanie html dokumentu: '
  //     + JSON.stringify(zaznamyTextu));

  //   this.http
  //     .post('/ais/rest/apps/vsk/ulozFormularAGenerujDokument/' + idDruhDokumentu, zaznamyTextu)
  //     .subscribe(data => {
  //       console.log('Data su ulozene na servri a dokument je spat :)');
  //       // this.zaznamyTextuDataSaved.next(data);
  //     });
  // }

  ulozFormularAGenerujDokument(zaznamyTextu: ZaznamTextu[], idTypDokumentu: number,
    idDruhDokumentu: number, fakulta: string,
    idStudProgram: number, idPodprogram: number, idOsoba: number,
    kodyJazykov: string, generovatStudProgramyPodprogramu: boolean,
    requestZKlientaParametre? : RequestZKlienta, idStavDokumentu?: number) {

    if (zaznamyTextu.length === 0) {
      const text: string = this.idPodprogram > 0 ? this.translateService.instant('pre podprogram') : '';
      this.spinnerChanged.next(false);
      this.openErrorDialog(this.translateService.instant('Dokument') + ' ' + text + ' '
        + this.translateService.instant('v')
        + ' ' + kodyJazykov + ' '
        + this.translateService.instant('verzii sa nepodarilo vygenerovať') + ', '
        + this.translateService.instant('pretože formulár v') + ' ' + kodyJazykov + ' '
        + this.translateService.instant('jazyku je prázdny') + '.');
      return;
    }

    // console.log('kodJazyk: ' + kodyJazykov);
    // console.log('Zaslanie dat formulara na server (ulozFormularAGenerujDokument): '
    //   + JSON.stringify(zaznamyTextu));


    this.spinnerChanged.next(true);

    const stavDokumentu = this.mapaStavovDokumentovPreIchJazyky.get(kodyJazykov);

    const idStavDokumentuURL = idStavDokumentu ? '/' + idStavDokumentu :
      stavDokumentu ? '/' + stavDokumentu.idStavDokumentu : '/' + -1;

    if (!requestZKlientaParametre) {
      requestZKlientaParametre = new RequestZKlienta();
    }
    requestZKlientaParametre.zaznamyTextu = zaznamyTextu;

    // const haha = [zaznamyTextu, jazykKdeNechcemNovuVerziu];
    // const hihi = {'zaznamyTextu': zaznamyTextu, };
    this.http.post('/ais/rest/apps/vsk/ulozFormularAGenerujDokument/' + idTypDokumentu + '/'
        + idDruhDokumentu + '/' + fakulta + '/'
        + idStudProgram + '/' + idPodprogram + '/' + idOsoba + '/'
        + kodyJazykov + '/' + this.akRok?.replace('/','-') + '/' + generovatStudProgramyPodprogramu + idStavDokumentuURL,
        requestZKlientaParametre, {observe: 'response', responseType: 'arraybuffer'})
      .subscribe({
        next: (res) => {
          // console.log('Dokument stiahnutyyyyyyyyyyyyy');

          // data sa ulozili na server a my v aplikacii potrebujeme z DB prave tieto
          // cerstve data (STZaznamTextu)
          // TODO: asi sa da stiahnut sucasne dokument a data z DB, ale zatial neviem ako,
          // tak si ich stiahnem z DB znova.. v nejakej dalsej verzii to zoptimalizujem
          // TODO: toto robi problemy, ale neviem, ci to mozem vysmarit - skusim :)
          // this.stiahniAktualneZaznamyTextuZoServera(idDruhDokumentu, zaznamyTextu, idTypDokumentu);

          if (res instanceof HttpResponse) {
            if (res.body) {
              const blob = new Blob([res.body], {type: 'application/pdf'});
              const fileName = res.headers.get('filename');
              const hlaskaExportu = res.headers.get('hlaskaExportu');
              if (hlaskaExportu) {
                this.openErrorDialog(this.translateService.instant(hlaskaExportu));
              }
              FileSaver.saveAs(blob, fileName);
              // console.log('spinner sa vypina!');
            }
            this.spinnerChanged.next(false);
          }
        },
        error: (error: Error) => {
          this.openErrorDialog('Dokument v' + ' ' + kodyJazykov + ' '
            + this.translateService.instant('jazyku') + ' '
            + this.translateService.instant('sa nepodarilo stiahnuť' + '.'));
          this.spinnerChanged.next(false);
        }
    });
  }

  /** - requestZKlientaParametre - zaznamyTextu a info o stavoch dokumentov stud. programov podprogramu;
   * - idStavDokumentu - stav dokumentov osoby, stud. programu a podprogramu*/
  ulozFormularAGenerujDokumentVJazykoch(zaznamyTextu: ZaznamTextu[], idTypDokumentu: number,
    idDruhDokumentu: number, idStudProgram: number, idPodprogram: number, idOsoba: number,
    fakulta: string, generovatStudProgramyPodprogramu: boolean,
    requestZKlientaParametre? : RequestZKlienta) {

    // console.error('ulozFormularAGenerujDokumentSKEN');

    const existujeJazyk2VoFormulari = this.jazykyFormulara.length >= 2;
    const existujeJazyk3VoFormulari = this.jazykyFormulara.length >= 3;

    if (zaznamyTextu.length === 0) {
      this.spinnerChanged.next(false);
      this.openErrorDialog(this.translateService.instant('Formulár je prázdny, '
        + 'vyplňte minimálne jednu položku.'));
      return;
    }

    let zaznamyTextovJazyk1 = [];
    let zaznamyTextovJazyk2 = [];
    let zaznamyTextovJazyk3 = [];
    for (const z of zaznamyTextu) {
      switch (z.kodJazyk) {
        case this.jazykFormulara1:
          zaznamyTextovJazyk1.push(z);
          break;
        case this.jazykFormulara2:
          zaznamyTextovJazyk2.push(z);
          break;
        case this.jazykFormulara3:
          zaznamyTextovJazyk3.push(z);
          break;

        default:
          break;
      }
    }

    const text: string = this.idPodprogram > 0 ? this.translateService.instant('pre podprogram') : '';
    if (zaznamyTextovJazyk1.length === 0) {
      this.spinnerChanged.next(false);
      this.openErrorDialog(this.translateService.instant('Dokument') + ' ' + text
        + ' ' +  this.translateService.instant('v') + ' ' + this.jazykFormulara1 + ' '
        + this.translateService.instant('verzii sa nepodarilo vygenerovať') + ', '
        + this.translateService.instant('pretože') + ' '
        + this.translateService.instant('formulár v') + ' '
        + this.jazykFormulara1 + ' ' + this.translateService.instant('jazyku je prázdny') + '.');

      // JAZYK 2 - DOKUMENT v jazyku2
      // aj ked sa dokument v jazyku 1 nevygeneruje, chceme vygenerovat aspon ten v jazyku 2 a 3, ak taky jazyk existuje vo formulari
      // JAZYKY 2 a 3 - ak sa nam nepodarilo vygenerovat dokument pre jazyk 1, skusame dalsie 2 jazyky
      this.generujDokumentyPreJazyk2a3(existujeJazyk2VoFormulari, zaznamyTextovJazyk2, idTypDokumentu,
        idDruhDokumentu, fakulta, idStudProgram, idPodprogram, idOsoba, existujeJazyk3VoFormulari,
        zaznamyTextovJazyk3, generovatStudProgramyPodprogramu, requestZKlientaParametre);

    } else {
      // JAZYK 1 - vetva, ked existuju nejake zaznamy v jazyku 1
      this.spinnerChanged.next(true);

      if (!requestZKlientaParametre) {
        requestZKlientaParametre = new RequestZKlienta();
      }
      requestZKlientaParametre.zaznamyTextu = zaznamyTextovJazyk1;

      const stavDokumentuJazyk1 = this.mapaStavovDokumentovPreIchJazyky.get(this.jazykFormulara1);

      const idStavDokumentuURL = stavDokumentuJazyk1 ? '/' + stavDokumentuJazyk1.idStavDokumentu : '/' + -1;

      this.http
        .post('/ais/rest/apps/vsk/ulozFormularAGenerujDokument/'
          + idTypDokumentu
          + '/' + idDruhDokumentu
          + '/' + fakulta
          + '/' + idStudProgram
          + '/' + idPodprogram
          + '/' + idOsoba
          + '/' + this.jazykFormulara1
          + '/' + this.akRok?.replace('/','-') + '/' + generovatStudProgramyPodprogramu + idStavDokumentuURL,
          requestZKlientaParametre, {observe: 'response', responseType: 'arraybuffer'})
        .subscribe({
          next: (res) => {

          // JAZYK 2 - ak sa podarilo vygenerovat dokument v jazyku 1 idem na DOKUMENT v jazyku 2 -
          // JAZYK 2 - snaha o vygenerovanie dokumentu v jazyku 2
          // JAZYKY 2 a 3 - ak sa nam nepodarilo vygenerovat dokument pre jazyk 1, skusame dalsie 2 jazyky
          if (existujeJazyk2VoFormulari) {
            this.generujDokumentyPreJazyk2a3(existujeJazyk2VoFormulari, zaznamyTextovJazyk2, idTypDokumentu,
              idDruhDokumentu, fakulta, idStudProgram, idPodprogram, idOsoba, existujeJazyk3VoFormulari,
              zaznamyTextovJazyk3, generovatStudProgramyPodprogramu,
              requestZKlientaParametre)
          } else {
            this.stiahniAktualneZaznamyTextuZoServera(idDruhDokumentu, zaznamyTextu, idTypDokumentu);
          }

          // JAZYK 1
          if (res instanceof HttpResponse) {
            if (res.body) {
              const blob = new Blob([res.body], {type: 'application/pdf'});
              const fileName = res.headers.get('filename');
              FileSaver.saveAs(blob, fileName);
            }
          }
        },
        error: (error: Error) => {

          // JAZYKY 2 a 3 - ak sa nam nepodarilo vygenerovat dokument pre jazyk 1, skusame dalsie 2 jazyky
          this.generujDokumentyPreJazyk2a3(existujeJazyk2VoFormulari, zaznamyTextovJazyk2, idTypDokumentu,
            idDruhDokumentu, fakulta, idStudProgram, idPodprogram, idOsoba, existujeJazyk3VoFormulari,
            zaznamyTextovJazyk3, generovatStudProgramyPodprogramu,
            requestZKlientaParametre)

          // JAZYK 1
          const text1 = this.translateService.instant('Dokument v');
          const text2 = this.translateService.instant('jazyku sa nepodarilo stiahnuť.');
          this.openErrorDialog(text1 + ' ' + this.jazykFormulara1 + ' ' + text2);
          this.spinnerChanged.next(false);
        }
      });
    }

  }

  generujDokumentVJazyku2a3(idTypDokumentu: number, idDruhDokumentu: number, fakulta: string,
    idStudProgram: number, idPodprogram: number, idOsoba: number,
    zaznamyTextovJazyk2: ZaznamTextu[], existujeJazyk3VoFormulari: boolean, zaznamyTextovJazyk3: ZaznamTextu[],
    generovatStudProgramyPodprogramu: boolean, requestZKlientaParametre? : RequestZKlienta) {

    // JAZYK 2 - snaha o vygenerovanie dokumentu v jazyku 2
    this.spinnerChanged.next(true);
    const stavDokumentu = this.mapaStavovDokumentovPreIchJazyky.get(this.jazykFormulara2);
    const idStavDokumentuURL = stavDokumentu ? '/' + stavDokumentu.idStavDokumentu : '/' + -1;

    if (requestZKlientaParametre) {
      requestZKlientaParametre.zaznamyTextu = zaznamyTextovJazyk2;
    }

    this.http
      .post('/ais/rest/apps/vsk/ulozFormularAGenerujDokument/'
        + idTypDokumentu
        + '/' + idDruhDokumentu
        + '/' + fakulta
        + '/' + idStudProgram
        + '/' + idPodprogram
        + '/' + idOsoba
        + '/' + this.jazykFormulara2
        + '/' + this.akRok?.replace('/','-') + '/' + generovatStudProgramyPodprogramu + idStavDokumentuURL,
        requestZKlientaParametre ? requestZKlientaParametre : zaznamyTextovJazyk2,
        {observe: 'response', responseType: 'arraybuffer'})
      .subscribe({
        next: (res) => {

        // JAZYK 3 - az ked dobehne vetva pre jazyk 2, skusame stiahnut dokument v jazyku 3
        if (existujeJazyk3VoFormulari) {
          const stavDokumentu = this.mapaStavovDokumentovPreIchJazyky.get(this.jazykFormulara3);
          this.ulozFormularAGenerujDokument(zaznamyTextovJazyk3,
            idTypDokumentu, idDruhDokumentu, fakulta,
            idStudProgram, idPodprogram, idOsoba, this.jazykFormulara3,
            generovatStudProgramyPodprogramu, requestZKlientaParametre,
            stavDokumentu ? stavDokumentu.idStavDokumentu : -1);
        } else {
          this.stiahniAktualneZaznamyTextuZoServera(idDruhDokumentu,
            zaznamyTextovJazyk2, idTypDokumentu);
        }

        // JAZYK 2
        if (res instanceof HttpResponse) {
          if (res.body) {
            const blob = new Blob([res.body], {type: 'application/html'});
            const fileName = res.headers.get('filename');
            FileSaver.saveAs(blob, fileName);
          }
          if (!existujeJazyk3VoFormulari || zaznamyTextovJazyk3.length === 0) {
            this.spinnerChanged.next(false);
          }
        }

      },
      error: (error: Error) => {

        // JAZYK 3 - aj v pripade neuspechu stiahnutia dok. v jazyku 2 sa treba pokusit o stiahnutie dok. v jazyku 3
        if (existujeJazyk3VoFormulari) {
          const stavDokumentu = this.mapaStavovDokumentovPreIchJazyky.get(this.jazykFormulara3);
          this.ulozFormularAGenerujDokument(zaznamyTextovJazyk3,
            idTypDokumentu, idDruhDokumentu, fakulta,
            idStudProgram, idPodprogram, idOsoba, this.jazykFormulara3,
            generovatStudProgramyPodprogramu,
            requestZKlientaParametre,
            stavDokumentu ? stavDokumentu.idStavDokumentu : -1);
        }

        // JAZYK 2
        const text1 = this.translateService.instant('Dokument v');
        const text2 = this.translateService.instant('jazyku sa nepodarilo stiahnuť.');
        this.openErrorDialog(text1 + ' ' + this.jazykFormulara2 + ' ' + text2);
        this.spinnerChanged.next(false);

     }
    });

  }

  generujDokumentyPreJazyk2a3(existujeJazyk2: boolean, zaznamyTextovJazyk2: ZaznamTextu[], idTypDokumentu: number,
    idDruhDokumentu: number, fakulta: string, idStudProgram: number, idPodprogram: number, idOsoba: number,
    existujeJazyk3: boolean, zaznamyTextovJazyk3: ZaznamTextu[], generovatStudProgramyPodprogramu: boolean,
    requestZKlientaParametre? : RequestZKlienta) {

    if (existujeJazyk2) {
      // JAZYK 2 - DOKUMENT v jazyku 2 sa ma vygenerovat aj v pripade chyby generovania dokumentu v jazyku 1
      if (zaznamyTextovJazyk2.length > 0) {
        // JAZYK 2 a 3 - snaha o vygenerovanie dokumentu v jazyku 2 a 3
        this.generujDokumentVJazyku2a3(idTypDokumentu, idDruhDokumentu, fakulta, idStudProgram, idPodprogram,
            idOsoba, zaznamyTextovJazyk2, existujeJazyk3, zaznamyTextovJazyk3,
            generovatStudProgramyPodprogramu, requestZKlientaParametre);
      } else if (existujeJazyk3) {
          // JAZYK 3 - ak su zaznamy pre jazyk 2 prazdne
        const stavDokumentu = this.mapaStavovDokumentovPreIchJazyky.get(this.jazykFormulara3);
        this.ulozFormularAGenerujDokument(zaznamyTextovJazyk3,
          idTypDokumentu, idDruhDokumentu, fakulta,
          idStudProgram, idPodprogram, idOsoba, this.jazykFormulara3,
          generovatStudProgramyPodprogramu, requestZKlientaParametre,
          stavDokumentu ? stavDokumentu.idStavDokumentu : -1);
      }
      const text: string = this.idPodprogram > 0 ? 'pre podprogram' : '';
      if (zaznamyTextovJazyk2.length === 0) {
        this.spinnerChanged.next(false);
        this.openErrorDialog(this.translateService.instant('Dokument') + ' '
          + text + ' ' + 'v' + ' ' + this.jazykFormulara2 + ' '
          + this.translateService.instant('verzii sa nepodarilo vygenerovať') + ', '
          + this.translateService.instant('pretože') + this.translateService.instant('formulár v') + ' '
          + this.jazykFormulara2 + ' ' + this.translateService.instant('jazyku je prázdny') + '.');
      }
    }
  }

  stiahniAktualneZaznamyTextuZoServera(idDruhDokumentu: number, zaznamyTextu: ZaznamTextu[], idTypDokumentu: number) {
    if (idDruhDokumentu === this.DOKUMENT_TEXT_STUDIJNEHO_PROGRAMU_A_PODPROGRAMU) {
      this.fetchZaznamyTextuData(null, zaznamyTextu[0].idStudProgram, zaznamyTextu[0].idPodprogram,
        idDruhDokumentu,idTypDokumentu, null);
    } else if (idDruhDokumentu === this.DOKUMENT_TEXT_OSOBY) {
      this.fetchZaznamyTextuData(zaznamyTextu[0].idOsoba, null, null, idDruhDokumentu,
        idTypDokumentu, null);
    }
  }

  openErrorDialog(msg: string) {
    this.dialog.open(ErrorDialogComponent, {
      panelClass: 'alert-danger',
        data: {message: msg},
        width: '500px',
      });
  }

  openConfirmDialog(msg: string) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        panelClass: 'alert-danger',
        data: {message: msg},
        width: '500px',
      });

      return dialogRef;
  }

  openOKDialog(msg: string) {
    const dialogRef = this.dialog.open(OkDialogComponent, {
        data: {message: msg},
      });

      return dialogRef;
  }


  fetchCiselnikJazyk1Data(nazovCiselnika: string,
      atribut1: string, atribut2: string, zacRetazca: string) {

    // console.log('fetchCiselnikSKData zacRetazca: ' + zacRetazca);

    if (!this.atributySuValidne(nazovCiselnika, atribut1)) {
      return;
    }

    this.http
      .get<string[]>('/ais/rest/apps/vsk/ciselnikovePolozky?nazovCiselnika=' + nazovCiselnika
        + '&atribut1=' + atribut1 + '&atribut2=' + atribut2 + '&zacRetazca=' + zacRetazca + '&kodJazyk=' + this.jazykFormulara1)
      .subscribe(data => {
        this.ciselnikJazyk1DataFetched.next(data);
        console.log('fetchedCiselnikSKData');
      });
  }

  fetchCiselnikJazyk2Data(nazovCiselnika: string,
    atribut1: string, atribut2: string, zacRetazca: string) {

    // console.log('fetchCiselnikENData');
    if (!this.atributySuValidne(nazovCiselnika, atribut1)) {
      return;
    }

    this.http
      .get<string[]>('/ais/rest/apps/vsk/ciselnikovePolozky?nazovCiselnika=' + nazovCiselnika
        + '&atribut1=' + atribut1 + '&atribut2=' + atribut2 + '&zacRetazca=' + zacRetazca + '&kodJazyk=' + this.jazykFormulara2)
      .subscribe(data => {
        this.ciselnikJazyk2DataFetched.next(data);
        // console.log('fetchedCiselnikJazyk2Data');
      });
  }

  fetchCiselnikJazyk3Data(nazovCiselnika: string,
    atribut1: string, atribut2: string, zacRetazca: string) {

    // console.log('fetchCiselnikENData');

    if (!this.atributySuValidne(nazovCiselnika, atribut1)) {
      return;
    }

    this.http
      .get<string[]>('/ais/rest/apps/vsk/ciselnikovePolozky?nazovCiselnika=' + nazovCiselnika
        + '&atribut1=' + atribut1 + '&atribut2=' + atribut2 + '&zacRetazca=' + zacRetazca + '&kodJazyk=' + this.jazykFormulara3)
      .subscribe(data => {
        this.ciselnikJazyk3DataFetched.next(data);
        // console.log('fetchedCiselnikJazyk3Data');
      });
  }

  fetchCiselnikyData(nazvyCiselnikov: string[]) {
    // console.log('fetchCiselnikyData');

    this.http
      .get<string[][]>('/ais/rest/apps/vsk/ciselnikovePolozkyPole/nazvyCiselnikov=' + nazvyCiselnikov)
      .subscribe(data => {
        this.ciselnikyDataFetched.next(data);
        // console.log('fetchedCiselnikyData');

      });
  }


  fetchPocetPripustnychProgramovPodprogramuData() {

    this.http
      .get<number>('/ais/rest/apps/vsk/pripustne-stud-programy-podprogramu-pocet/'
        + this.idPodprogram + '/' + this.akRok?.replace('/','-'))
      .subscribe(data => {
        this.pocetPripustnychProgramovPodprogramuDataFetched.next(data);
        console.log('fetchedPocetPripustnychProgramovPodprogramuData');
      });
}


  zobrazitButtonOpakovaniaPrePodprogram(typ: TypZaznamuTextu): boolean {

    if (this.idPodprogram > 0 && typ.podprogram === 1) {
      return true;
    }

    return false;
  }

  zobrazitPomocnyTextPolozkyPodprogramu(typ: TypZaznamuTextu): boolean {
    if ((this.idPodprogram > 0 || this.idStudProgram > 0)
        && typ.podprogram > 0 && typ.podprogram !== this.POLOZKA_PONUKANA_LEN_PRE_PODPROGRAM) {
      return true;
    }
    return false;
  }


  // TODO:
  jeOpakovaniePodprogramu(typ: TypZaznamuTextu) : boolean {

    //v pripade formulara pre podprogram budeme za opakovane polozky podprogramu povazovat len tie, kde typ.podprogram === 1
    // ale zatial to nefunguje takto, az v buducnosti.. zatial sa tvarime, ze podprogram = 1 je to iste, ako podprogram = 2

    // if (typ.id === -2) {
    //   return true;
    // }

    if (!(typ.podprogram > 0) || typ.idSkupina) {
      return false;
    }

    if (this.idPodprogram > 0 && !(typ.podprogram === 1)) {
      return false;
    }

    if (typ.podprogram > 0 &&
        (this.idStudProgram > 0
        ||
        (this.idPodprogram > 0 && typ.podprogram === 1))
      ) {

      return true;
    }

    return false;
  }

  getSpolocnaPolozkaPodprogramuText(typZaznamu: TypZaznamuTextu, kodJazyk?: string, index?: number): string {

    if (this.idPodprogram > 0 && typZaznamu.podprogram > 0
        && typZaznamu.podprogram !== this.POLOZKA_PONUKANA_LEN_PRE_PODPROGRAM) {

      let result = '';
      if (typZaznamu.podprogram === this.OPAKOVANA_POLOZKA_PODPROGRAMU ) { // 1
        result = this.translateService.instant('spoločná položka formulára evidovaná pre vybranú množinu študijných programov') + ':';
      } else if (typZaznamu.podprogram === this.SPOLOCNA_POLOZKA_VSETKY_STUD_PROGRAMY) { // 2
        result = this.translateService.instant('spoločná položka formulára pre všetky študijné programy podprogramu, časti študijného programu');
      } else if (typZaznamu.podprogram === this.POSLEDNA_PRIDANA_POLOZKA_PODPROGRAMU) { // 4
        result += this.translateService.instant('len jedna spoločná položka v dokumente pre všetky študijné programy podprogramu');
      }

      return result;
    }

    if (index < 0 || !(this.idStudProgram > 0)
      || !this.mapaIdTypovAMapJazykovAZaznamovsPodprogramami.get(typZaznamu.id)
      || !this.mapaIdTypovAMapJazykovAZaznamovsPodprogramami.get(typZaznamu.id).get(kodJazyk)) {

      return null;
    }

    let result = '';

    const zaznamy = this.mapaIdTypovAMapJazykovAZaznamovsPodprogramami.get(typZaznamu.id).get(kodJazyk);
    if (zaznamy.length > index) {
      result = this.translateService.instant('Spoločná položka podprogramu') + ' ' +
        zaznamy[index].podprogram;
    }

    return result;
  }

  vymazObsahPolozkyFormulara(formularFormGroup: UntypedFormGroup, typZaznamuTextu: TypZaznamuTextu,
      jazyk: string, index? : number) {

    let name = 'name_' + typZaznamuTextu.id + '_' + jazyk;
    if (typZaznamuTextu.opakovanie !== 'A' && !typZaznamuTextu.idSkupina
        && !this.jeOpakovaniePodprogramu(typZaznamuTextu)) {
      formularFormGroup.get(name).reset();
    } else {
      // OPAKOVANA POLOZKA
      if (index >= 0) {
        // SKUPINOVE OPAKOVANIE
        if (typZaznamuTextu.idSkupina) {
          const name = 'name_' + typZaznamuTextu.idSkupina + '_' + jazyk;
          formularFormGroup.get(name).get(index.toString()).reset();
        } else {
          const name = 'name_' + typZaznamuTextu.id + '_' + jazyk;
          formularFormGroup.get(name).get(index.toString()).reset();
        }
      }

      // toto potrebujeme kvoli mazaniu polozky podprogramu v stud. programe
      // - chceme totiz vynimocne v tomto pripade umoznit poslanie prazdnej polozky na server,
      // aby sa nasledne v podprograme javila ako prazdna
      // if (this.idStudProgram > 0 && typZaznamuTextu.podprogram && typZaznamuTextu.podprogram > 0) {
      //   if (!this.mapaIdTypovAMapJazykovAPoradiZaznamov.get(typZaznamuTextu.id)) {
      //     const mapa: Map<string, number[]> = new Map();
      //     mapa.set(jazyk, [index+1]);
      //     this.mapaIdTypovAMapJazykovAPoradiZaznamov.set(typZaznamuTextu.id, mapa);
      //   } else {
      //     const mapa = this.mapaIdTypovAMapJazykovAPoradiZaznamov.get(typZaznamuTextu.id);
      //     if (!mapa.get(jazyk)) {
      //       mapa.set(jazyk, [index+1]);
      //     } else {
      //       mapa.get(jazyk).push(index+1);
      //     }
      //   }
      // }

    }
  }


  ziskajStavyDokumentov() {

    // !!! ZO SERVRA NAM PRIDU LEN TAKE STAVY< KTORE SU NEEDITOVATELNE (patria medzi ne aj koncove) !!!
    this.http.get<Object[]>('/ais/rest/apps/vsk/stav-dokumentu/'
        + this.idTypDokumentu
        + '/' + this.idDruhDokumentuDB
        + '/' + this.idPodprogram
        + '/' + this.idStudProgram
        + '/' + this.idOsoba
        + '/' + this.akRok?.replace('/','-'))
      .subscribe({
        next: (stavyDokumentovNeaktualizovatelne: StavDokumentu[]) => {

          // console.log('Stavy dokumentov: ' + JSON.stringify(stavyDokumentovNeaktualizovatelne));

          if (stavyDokumentovNeaktualizovatelne) {

            // this.studProgramySKoncovymiStavmiDokumentov = [];
            this.studProgramySoZakazanymiStavmiDokumentov = [];
            this.mapaJazykovDokumentovSoZakazanymiStavmiAIchStudijnychProgramov = new Map();
            this.mapaStudProgramovSoZakazanymiStavmiDokumentovAPoliIchJazykov = new Map();
            let upozornenieText = '';

            // VETVA PRE FORMULAR PODPROGRAMU
            if (this.idPodprogram > 0) {

              // ak ide o formular podprogramu, tak zo servera nam prisli stavy dokumentu
              // pre dany podprogram + stavy dokumentov vsetkych jeho pripustnych stud. progaramov

              // TODO: tu treba zistit, ci su v nevyhovujucom stave len dokumenty pre podprogram,
              // alebo aj stud. program
              let zakazaneStavyPodprogram: StavDokumentu[] = [];
              let koncoveStavyPodprogram: StavDokumentu[] = [];
              // let neaktualizovatelneStavyStudProgramy: StavDokumentu[] = [];
              // let studProgramyVNeaktualizovatelnychStavochSkratky: string[] = [];
              // let mapa: Map<string, string>
              // const stavyUzavretaVerzia = [6,7,10];
              for (const stav of stavyDokumentovNeaktualizovatelne) {

                if (stav.idPodprogram) {
                  if (stav.somStavUzavretaVerzia) {
                    this.mapaStavovDokumentovPreIchJazyky.set(stav.kodJazykDokumentu, stav);
                    koncoveStavyPodprogram.push(stav);
                    this.mapaUzavretychStavovDokumentovPreIchJazyky.set(stav.kodJazykDokumentu, stav);
                  } else {
                    this.mapaStavovDokumentovPreIchJazyky.set(stav.kodJazykDokumentu, stav);
                    zakazaneStavyPodprogram.push(stav);
                    if (!this.poleNeeditovatelnychStavovString.includes(stav.stavPopis)) {
                      this.poleNeeditovatelnychStavovString.push(stav.stavPopis);
                    }
                    if (!this.jazykyDokumentovVZakazanychStavoch.includes(stav.kodJazykDokumentu)) {
                      this.jazykyDokumentovVZakazanychStavoch.push(stav.kodJazykDokumentu);
                    }
                    this.mapaZakazanychStavovDokumentovPreIchJazyky.set(stav.kodJazykDokumentu, stav);
                  }

                  // TODO: mapa stavov a jazykov pre podprogramy

                } else {
                  // STUD. PROGRAMY PODPROGRAMU

                  // neaktualizovatelneStavyStudProgramy.push(stav);
                  // studProgramyVNeaktualizovatelnychStavochSkratky.push(stav.studProgram);

                  // TODO: netreba tu tiez naplnit mapu stavov v jazykoch???

                  if (stav.somStavUzavretaVerzia) {
                    if (!this.mapaJazykovDokumentovSKoncovymiStavmiAIchStudijnychProgramov.get(stav.kodJazykDokumentu)) {
                      this.mapaJazykovDokumentovSKoncovymiStavmiAIchStudijnychProgramov.set(stav.kodJazykDokumentu, [stav.studProgram]);
                    } else {
                      const studProgramyPole = this.mapaJazykovDokumentovSKoncovymiStavmiAIchStudijnychProgramov.get(stav.kodJazykDokumentu);
                      if (!studProgramyPole.includes(stav.studProgram)) {
                        this.mapaJazykovDokumentovSKoncovymiStavmiAIchStudijnychProgramov.get(stav.kodJazykDokumentu).push(stav.studProgram);
                      }
                    }
                    // if (!this.jazykyDokumentovSPPodprogramuVKoncovomStave.includes(stav.kodJazykDokumentu)) {
                    //   this.jazykyDokumentovSPPodprogramuVKoncovomStave.push(stav.kodJazykDokumentu);
                    // }


                  } else {
                    // zakazane stavy (needitovatelne a nie koncove (uzavrete))
                    // TODO: riadok prec??
                    this.studProgramySoZakazanymiStavmiDokumentov.push(stav.studProgram);

                    if (!this.mapaJazykovDokumentovSoZakazanymiStavmiAIchStudijnychProgramov.get(stav.kodJazykDokumentu)) {
                      this.mapaJazykovDokumentovSoZakazanymiStavmiAIchStudijnychProgramov.set(stav.kodJazykDokumentu, [stav.studProgram]);
                    } else {
                      const studProgramyPole = this.mapaJazykovDokumentovSoZakazanymiStavmiAIchStudijnychProgramov.get(stav.kodJazykDokumentu);
                      if (!studProgramyPole.includes(stav.studProgram)) {
                        this.mapaJazykovDokumentovSoZakazanymiStavmiAIchStudijnychProgramov.get(stav.kodJazykDokumentu).push(stav.studProgram);
                      }
                    }

                    // TODO: mapa prec???
                    if (!this.mapaStudProgramovSoZakazanymiStavmiDokumentovAPoliIchJazykov.get(stav.studProgram)) {
                      this.mapaStudProgramovSoZakazanymiStavmiDokumentovAPoliIchJazykov.set(stav.studProgram, [stav.kodJazykDokumentu]);
                    } else {
                      const jazykyPole = this.mapaStudProgramovSoZakazanymiStavmiDokumentovAPoliIchJazykov.get(stav.studProgram);
                      if (!jazykyPole.includes(stav.kodJazykDokumentu)) {
                        this.mapaStudProgramovSoZakazanymiStavmiDokumentovAPoliIchJazykov.get(stav.studProgram).push(stav.kodJazykDokumentu);
                      }
                    }
                  }

                }

              }

              // TODO: riadok prec???
              this.studProgramySoZakazanymiStavmiDokumentov = [...new Set(this.studProgramySoZakazanymiStavmiDokumentov)];

              this.existujeNevyhovujuciStavDokumentov = zakazaneStavyPodprogram.length > 0;
              // dokumenty pre podprogram
              this.niektoryZDokumentovJeVKoncovomStave = koncoveStavyPodprogram.length > 0;
              // console.log("HAHA: " + JSON.stringify(this.mapaUzavretychStavovDokumentovPreIchJazyky));

              if (zakazaneStavyPodprogram.length > 0 && this.studProgramySoZakazanymiStavmiDokumentov.length > 0) {
                // 1. ak je v zlom stave dokument pre podprogram aj pre stud. programy podprogramu

                // TODO: vetva, ak je dokument pre podprogram a aj nejaky pre stud. programy podprogramu v zlom stave
                let studProgramyAJazykyString = '';
                let i = 0;
                for (const studProgram of this.studProgramySoZakazanymiStavmiDokumentov) {
                  if (i >= 1 && i < this.studProgramySoZakazanymiStavmiDokumentov.length) {
                    studProgramyAJazykyString += ', ';
                  }
                  const jazykyDokumentov =  this.mapaStudProgramovSoZakazanymiStavmiDokumentovAPoliIchJazykov.get(studProgram);
                  studProgramyAJazykyString += studProgram + ' (' + jazykyDokumentov.join(', ') + ')';
                  i++;
                }
                upozornenieText = this.translateService.instant('Dokument pre podprogram v jazyku') + ' ' + this.jazykyDokumentovVZakazanychStavoch.join(', ')
                  + ' ' + this.translateService.instant('a dokumenty pre študijné programy') + ' ' + studProgramyAJazykyString +  ' ' + this.translateService.instant('nebude možné vygenerovať') + ', '
                  + this.translateService.instant('pretože dokumenty pre tento podprogram a uvedené štud. programy sú v stave, ktorý neumožňuje aktualizáciu') + '. '
                  + this.translateService.instant('Je však možné formulár priebežne uložiť') + '.';

                this.existujeNevyhovujuciStavDokumentovSPPodprogramu = true;

              } else if (zakazaneStavyPodprogram.length > 0) {
              // 2. ak je v zlom stave iba dokument pre podprogram

                const stavText = zakazaneStavyPodprogram[0].stavPopis;
                upozornenieText =
                  this.translateService.instant('Dokument pre podprogram nebude možné vygenerovať') + ', '
                  + this.translateService.instant('pretože tento dokument je v stave') + ' ' + '\"' + stavText  + '\"' +  + ', '
                  + this.translateService.instant('ktorý neumožňuje aktualizáciu') + '. '
                  + this.translateService.instant('Je však možné formulár priebežne uložiť') + '.';

                this.existujeNevyhovujuciStavDokumentov = true;

              } else if (this.studProgramySoZakazanymiStavmiDokumentov.length > 0) {
                // 3. ak je v zlom stave iba dokument pre stud. programy podprogramu


                if (this.studProgramySoZakazanymiStavmiDokumentov.length === 1) {

                  const studProgram = this.studProgramySoZakazanymiStavmiDokumentov[0];
                  const jazykyDokumentov =  this.mapaStudProgramovSoZakazanymiStavmiDokumentovAPoliIchJazykov.get(studProgram);
                  upozornenieText = this.translateService.instant('Dokument pre študijný program') + ' '
                    + studProgram + ' ' + this.translateService.instant('v jazyku') + ' '
                    + jazykyDokumentov.join(', ') + ' ' + this.translateService.instant('nebude možné vygenerovať') + ', '
                    + this.translateService.instant('pretože dokument tohto štud. programu je v stave, ktorý neumožňuje aktualizáciu') + '. '
                    + this.translateService.instant('Je však možné formulár priebežne uložiť a generovať dokument pre podprogram') + '.';


                } else {

                  let studProgramyAJazykyString = '';
                  let i = 0;
                  for (const studProgram of this.studProgramySoZakazanymiStavmiDokumentov) {
                    if (i >= 1 && i < this.studProgramySoZakazanymiStavmiDokumentov.length) {
                      studProgramyAJazykyString += ', ';
                    }
                    const jazykyDokumentov =  this.mapaStudProgramovSoZakazanymiStavmiDokumentovAPoliIchJazykov.get(studProgram);
                    studProgramyAJazykyString += studProgram + ' (' + jazykyDokumentov.join(', ') + ')';
                    i++;
                  }
                  upozornenieText = this.translateService.instant('Dokumenty pre študijné programy') + ' '
                    + studProgramyAJazykyString + ' '
                    + this.translateService.instant('nebude možné vygenerovať') + ', '
                    + this.translateService.instant('pretože dokumenty týchto štud. programov v uvedených jazykoch sú v stave, ktorý neumožňuje aktualizáciu') + '. '
                    + this.translateService.instant('Je však možné formulár priebežne uložiť a generovať dokument pre podprogram') + '.';
                }

                this.existujeNevyhovujuciStavDokumentovSPPodprogramu = true;
              }
              // else {
              //   upozornenieText = 'Dokumenty pre študijné programy podprogramu nebude možné vygenerovať, '
              //   + 'pretože niektorý z generovaných dokumentov je v stave, ktorý neumožňuje aktualizáciu. '
              //   + 'Je však možné formulár priebežne uložiť.';
              // }


            } else {

              // dokumenty pre stud. program, osobu, ... (teda nie podprogram)

              // verzia 708 - potrebujeme rozlisit dokumenty s roznymi jazykmi !!!
              // console.log(JSON.stringify(stavyDokumentovNeaktualizovatelne));

              for (const jazyk of this.jazykyFormulara) {
                for (const stav of stavyDokumentovNeaktualizovatelne) {
                  if (!stav.somStavUzavretaVerzia && stav.kodJazykDokumentu === jazyk) {
                    if (!this.jazykyDokumentovVZakazanychStavoch.includes(jazyk)) {
                      this.jazykyDokumentovVZakazanychStavoch.push(jazyk);
                    }
                  }
                }


                // stavyDokumentovNeaktualizovatelne.length / 3;
              }

              //TODO: tu nam uz nestaci pozriet na prvy prvok pola..
              const stav = stavyDokumentovNeaktualizovatelne[0];

              if (stavyDokumentovNeaktualizovatelne) {
                for (const stavDokumentu of stavyDokumentovNeaktualizovatelne) {
                  this.mapaStavovDokumentovPreIchJazyky.set(stavDokumentu.kodJazykDokumentu, stavDokumentu);
                }

                for (const jazykDokumentu of this.mapaStavovDokumentovPreIchJazyky.keys()) {
                  const stavVJazyku = this.mapaStavovDokumentovPreIchJazyky.get(jazykDokumentu);
                  if (stavVJazyku.somNeeditovatelnyStav) {
                    this.poleNeeditovatelnychStavovString.push(stavVJazyku.stavPopis);
                    this.mapaZakazanychStavovDokumentovPreIchJazyky.set(jazykDokumentu, stav);
                  } else if (stavVJazyku.somStavUzavretaVerzia) {
                    this.mapaUzavretychStavovDokumentovPreIchJazyky.set(jazykDokumentu, stavVJazyku);
                  }
                }

              }


              if (this.poleNeeditovatelnychStavovString.length > 0) {

                if (this.poleNeeditovatelnychStavovString.length === 1) {
                  upozornenieText = this.translateService.instant('Dokument v') + ' ' + this.jazykyDokumentovVZakazanychStavoch.join(', ')
                  + ' ' + this.translateService.instant('jazyku') + ' ' + this.translateService.instant('nebude možné vygenerovať') + ', '
                  + this.translateService.instant('pretože je v stave') + ' ' + "\"" + this.poleNeeditovatelnychStavovString[0] + "\""  + ', '
                  + this.translateService.instant('ktorý neumožňuje aktualizáciu') + '. '
                  + this.translateService.instant('Je však možné formulár priebežne uložiť.');
                } else {
                  upozornenieText = this.translateService.instant('Dokumenty v') + ' ' + this.jazykyDokumentovVZakazanychStavoch.join(', ')
                  + ' ' + this.translateService.instant('jazyku') + this.translateService.instant('nebude možné vygenerovať') + ', '
                  + this.translateService.instant('pretože sú v stavoch') + '' + "\"" + this.poleNeeditovatelnychStavovString.join(', ')
                  + "\""  + ', ' + this.translateService.instant('ktoré neumožňujú aktualizáciu') + '. '
                  + this.translateService.instant('Je však možné formulár priebežne uložiť.');
                }


                this.existujeNevyhovujuciStavDokumentov = true;
                // console.log('JAZYKY FORMULARA: ' + this.jazykyFormulara);
                // if (this.jazykyDokumentovVZakazanychStavoch.length === this.jazykyFormulara.length) {
                //   this.dokumentyVoVsetkychJazykochSuVZakazanomStave = true;
                // }

              }

              this.niektoryZDokumentovJeVKoncovomStave = this.mapaUzavretychStavovDokumentovPreIchJazyky.size > 0;

            }

            if (upozornenieText) {
              this.openErrorDialog(upozornenieText);
            }

          }

        },

        error: (error) => {
          console.error(error);
          // this.openErrorDialog(error.message)
        }

    })

  }

  kontrolaNeeditovatelnychStavovDokumentovSPPodprogramuPreZvolenyJazyk(requestParametre?: RequestZKlienta) : RequestZKlienta {

    let requestZKlienta: RequestZKlienta = requestParametre ? requestParametre : new RequestZKlienta();;
    if (this.existujeNevyhovujuciStavDokumentovSPPodprogramu) {

      let upozornenie = '';
      const vybraneJazykyFormularaPole = this.vybranyJazykFormulara.split(', ');
      const jazykyDokumentovSPVZakazanychStavoch =
        Array.from(this.mapaJazykovDokumentovSoZakazanymiStavmiAIchStudijnychProgramov.keys());

      const prienikJazykovFormularaAZakazanychStavovDokumentovSP
        = jazykyDokumentovSPVZakazanychStavoch
        .filter(x => vybraneJazykyFormularaPole.includes(x));

      if (prienikJazykovFormularaAZakazanychStavovDokumentovSP.length > 0) {

        if (vybraneJazykyFormularaPole.length === 1) {

          // ak mam vo formulari vybrany prave 1 jazyk

          const jazykDokumentov =  prienikJazykovFormularaAZakazanychStavovDokumentovSP[0];
          const studProgramyZakazaneStavyPole = this.mapaJazykovDokumentovSoZakazanymiStavmiAIchStudijnychProgramov.get(jazykDokumentov);

          upozornenie = this.translateService.instant('Dokument pre štud. program') + ' ' + studProgramyZakazaneStavyPole.join(', ')
          + ' ' + this.translateService.instant('nebude možné vygenerovať') + ', '
          + this.translateService.instant('pretože dokument pre štud. program') + ' '
          + studProgramyZakazaneStavyPole.join(', ') + ' ' + this.translateService.instant('v jazyku') + ' ' + jazykDokumentov
          + ' ' + this.translateService.instant('je v stave, ktorý neumožňuje aktualizáciu') + '.';

          this.openErrorDialog(upozornenie);

          const studProgramyStavyPreJazyky = new StudijneProgramyStavPreJazyk();
          studProgramyStavyPreJazyky.jazyk = jazykDokumentov;
          studProgramyStavyPreJazyky.studProgramyNeeditovatelnyStav = studProgramyZakazaneStavyPole;
          requestZKlienta.studijneProgramyStavPreJazyk = [studProgramyStavyPreJazyky];

        } else {

          // ak som si vo formulari zvolil kombinaciu jazykov..

          const jazykyDokumentov =  prienikJazykovFormularaAZakazanychStavovDokumentovSP;
          let studProgramyVyslednePole = [];
          const studProgramyStavyPreJazykyPole: StudijneProgramyStavPreJazyk[] = [];
          for (const jazyk of jazykyDokumentov) {
            const studProgramyZakazanyStav = this.mapaJazykovDokumentovSoZakazanymiStavmiAIchStudijnychProgramov.get(jazyk);
            for (const studProgram of studProgramyZakazanyStav) {
              if (!studProgramyVyslednePole.includes(studProgram)) {
                studProgramyVyslednePole.push(studProgram);
              }
            }

            const studProgramyStavyPreJazyky = new StudijneProgramyStavPreJazyk();
            studProgramyStavyPreJazyky.jazyk = jazyk;
            studProgramyStavyPreJazyky.studProgramyNeeditovatelnyStav = studProgramyZakazanyStav;
            studProgramyStavyPreJazykyPole.push(studProgramyStavyPreJazyky);
          }
          requestZKlienta.studijneProgramyStavPreJazyk = studProgramyStavyPreJazykyPole;

          let studProgramyAJazykyString = '';
          let i = 0;
          for (const studProgram of studProgramyVyslednePole) {
            if (i >= 1 && i < studProgramyVyslednePole.length) {
              studProgramyAJazykyString += ', ';
            }
            const jazykyDokumentov =  this.mapaStudProgramovSoZakazanymiStavmiDokumentovAPoliIchJazykov.get(studProgram);
            studProgramyAJazykyString += studProgram + ' (' + jazykyDokumentov.join(', ') + ')';
            i++;
          }

          if (prienikJazykovFormularaAZakazanychStavovDokumentovSP.length < this.jazykyFormulara.length) {
            upozornenie = this.translateService.instant('Dokument v jazyku') + ' ' + jazykyDokumentov.join(', ')
            + ' ' + this.translateService.instant('nie je možné vygenerovať') + ', '
            + this.translateService.instant('pretože dokumenty pre štud. programy') + ' '
            + studProgramyAJazykyString
            + ' ' + this.translateService.instant('sú v stave, ktorý neumožňuje aktualizáciu') + '.'
            +  this.translateService.instant('Budú však vygenerované dokumenty pre ostatné jazyky') + '.';

            this.openErrorDialog(upozornenie);

            //TODO: request

          } else {

              // situacia, ked
              // prienikJazykovFormularaAZakazanychStavovDokumentovSP.length === this.jazykyFormulara.length

              // dokumenty vo vsetkych jazykoch su v zakazanom stave
              upozornenie = this.translateService.instant('Dokumenty pre štud. programy') + ' ' + studProgramyVyslednePole.join(', ')
              + ' ' + this.translateService.instant('nie je možné vygenerovať') + ', '
              + this.translateService.instant('pretože dokumenty pre štud. programy') + ' '
              + studProgramyAJazykyString
              + ' ' + this.translateService.instant('sú v stave, ktorý neumožňuje aktualizáciu') + '.';

              this.openErrorDialog(upozornenie);

          }

        }

      }

    }

    return requestZKlienta;
  }


  /** metoda pre kontrolu stavov dokumentov podprogramu,
    stud. programu a osoby (!pozor, nie dokumentov pripustnych stud. programov podprogramu!)
    "zakazany stav" je stav rozny od stavov MOZNA_UPRAVA (PRACOVNA_VERZIA, ZAMIETNUTY_FSO_UPRAVA, ZAMIETNUTY_USO_UPRAVA)
    a UZAVRETA_VERZIA (SCHVALENY_USO, ZAMIETNUTY_USO, ZAMIETNUTY_RSP) z triedy SCSTStavyDokumentou.java  */
  kontrolaDokumentovVZakazanomStave(): boolean {

    // if (this.existujeNevyhovujuciStavDokumentov || this.dokumentyVoVsetkychJazykochSuVNevyhovujucomStave) {
    //TODO: toto by bolo fajn prerobit tak, aby to bralo do uvahy jazyk - takto je to zatial velmi
    // vseobecne a zbytocne sa kontroluje nieco, co nemusi
    const vybraneJazykyFormularaPole = this.vybranyJazykFormulara.split(', ');
    if (this.existujeNevyhovujuciStavDokumentovVJazyku(vybraneJazykyFormularaPole)) {

      const prienikJazykovFormularaAZakazanychStavov = this.jazykyDokumentovVZakazanychStavoch
        .filter(x => vybraneJazykyFormularaPole.includes(x));

      let poleNeeditovatelnychStavovPreJazykFormulara: string[]= [];
      for (const jazyk of prienikJazykovFormularaAZakazanychStavov) {
        const zakazanyStavPreJazyk = this.mapaZakazanychStavovDokumentovPreIchJazyky.get(jazyk);
        if (zakazanyStavPreJazyk) {
          const stav = zakazanyStavPreJazyk.stavPopis;
          if (stav) {
            poleNeeditovatelnychStavovPreJazykFormulara.push(stav);
          }
        }
      }

      // kontrolu riesime len ak je problem s dokumentom v konkretnom jazyku, ktory mame vybrany v radioboxe
      if (prienikJazykovFormularaAZakazanychStavov.length > 0) {

        // const jazykyNeaktualizovatelnychDokumentovString = this.jazykyDokumentovVZakazanychStavoch.join(', ');

        let text = '';
        if (this.idPodprogram > 0) {
          text = this.translateService.instant('podprogramu');
        } else if (this.idStudProgram > 0) {
          text = this.translateService.instant('štud. programu')
        }

        if (prienikJazykovFormularaAZakazanychStavov.length === 1) {
          // console.log('HAHAHAHAHAHAHA');
          const stavPopis = ' ' + poleNeeditovatelnychStavovPreJazykFormulara[0];
          this.openErrorDialog(this.translateService.instant('Dokument') + ' ' + text + ' v ' + prienikJazykovFormularaAZakazanychStavov[0]
            + ' ' + this.translateService.instant('jazyku') + ' ' + this.translateService.instant('nebude možné vygenerovať') + ', '
            + this.translateService.instant('pretože je v stave') + ' ' + '\"'
            + stavPopis + "\"" + ', ' + this.translateService.instant('ktorý neumožňuje aktualizáciu') + '. ');

            // ak sme zvolil na formulari prave 1 jazyk a dokument v tomto jazyku je v needitovatelnom stave,
            // tak koncime, nie je co riesit
            if (vybraneJazykyFormularaPole.length === 1) {
              return false;
            }

        } else if (prienikJazykovFormularaAZakazanychStavov.length < this.jazykyFormulara.length) {
          // pripad, ze viac
          this.openErrorDialog(this.translateService.instant('Dokumenty') + ' ' + text
            + ' ' + this.translateService.instant('v jazykoch') + ' '
            + prienikJazykovFormularaAZakazanychStavov.join(', ') + ' ' + this.translateService.instant('nebude možné vygenerovať') + ', '
            + this.translateService.instant('pretože sú v stave') + ' '
            + '\"' + poleNeeditovatelnychStavovPreJazykFormulara.join(', ') + '\"' + ', '
            + this.translateService.instant('ktorý neumožňuje aktualizáciu') + '.'
            + ' ' + this.translateService.instant('Budú však vygenerované dokumenty v ostatných jazykoch') + '.');
        } else {
          // dokumenty vo vsetkych jazykoch su v zakazanom stave
          this.openErrorDialog(this.translateService.instant('Dokumenty') + ' ' + text + ' '
            + this.translateService.instant('v jazykoch') + ' ' + prienikJazykovFormularaAZakazanychStavov.join(', ') + ' '
            + this.translateService.instant('nebude možné vygenerovať') + ', '
            + this.translateService.instant('pretože sú v stave') + ' '
            + '\"' + poleNeeditovatelnychStavovPreJazykFormulara.join(', ') + '\"'
            + ', ' + this.translateService.instant('ktorý neumožňuje aktualizáciu') + '.');

            return false;
        }

      }

    }

    return true;

  }

  niektoryZDokumentovVJazykuJeVKoncovomStave(jazyky: string[]): boolean {
    for (const jazyk of jazyky) {
      if (this.mapaUzavretychStavovDokumentovPreIchJazyky.get(jazyk)) {
        return true;
      }
    }
    return false;
  }

  /** zakazane stavy (needitovatelne a nie koncove) */
  existujeNevyhovujuciStavDokumentovVJazyku(jazyky: string[]): boolean {
    for (const jazyk of jazyky) {
      if (this.mapaZakazanychStavovDokumentovPreIchJazyky.get(jazyk)) {
        return true;
      }
    }
    return false;
  }


  fetchInfoOExistenciiDokumentov() {

    // TODO: spinnery podla fetchData (riadok 91)

    const vybraneJazykyFormularaPole = this.vybranyJazykFormulara.split(', ');
    const vybraneJazykyFormularaString = vybraneJazykyFormularaPole.join('-');
    this.http.get('/ais/rest/apps/vsk/existencia-dokumentov' +
      '/' + this.idTypDokumentu +
      '/' + this.idDruhDokumentuDB +
      '/' + this.idPodprogram +
      '/' + this.idStudProgram +
      '/' + this.idOsoba +
      '/' + (this.akRok?.replace('/','-')) +
      '/' + vybraneJazykyFormularaString)
    .subscribe(data => {
      this.infoOExistenciiDokumentovDataFetched.next(data);
    });


  }

  atributySuValidne(nazovCiselnika: string, atribut1: string) : boolean {
    if (!nazovCiselnika || nazovCiselnika.length === 0 || !atribut1 || atribut1.length === 0) {
      return false;
    }

    return true;
  }

  fetchStudProgramyZRegistraData(hladanyRetazec: string) {
    this.http
      .get<StudijnyProgram[]>('/ais/rest/apps/vsk/studProgramyZRegistra' +
      '/' + hladanyRetazec +
      '/' + this.idStudProgram +
      '/' + (this.akRok?.replace('/','-')) +
      '/' + this.fakulta +
      '/' + this.haikOdbor)
      .subscribe(data => {
        this.studProgramyZRegistraDataFetched.next(data);
      });
  }

  fetchPodprogramyZRegistraData(hladanyRetazec: string) {
    this.http
      .get<StudijnyProgram[]>('/ais/rest/apps/vsk/podprogramyZRegistra' +
      '/' + hladanyRetazec +
      '/' + this.idPodprogram +
      '/' + (this.akRok?.replace('/','-')) +
      '/' + this.fakulta)
      .subscribe(data => {
        this.podprogramyZRegistraDataFetched.next(data);
      });
  }

  fetchJazykyFormularaStudProgramu(idStudProgram: number) {
    this.http
      .get<string[]>('/ais/rest/apps/vsk/jazykyPoloziekFormularaStudProgramu' +
      '/' + this.idTypDokumentu +
      '/' + idStudProgram)
      .subscribe(data => {
        this.jazykyPoloziekDokumentuStudProgramuDataFetched.next(data);
      });
  }

  fetchJazykyFormularaPodprogramu(idPodprogram: number) {
    this.http
      .get<string[]>('/ais/rest/apps/vsk/jazykyPoloziekFormularaPodprogramu' +
      '/' + this.idTypDokumentu +
      '/' + idPodprogram)
      .subscribe(data => {
        this.jazykyPoloziekDokumentuPodprogramuDataFetched.next(data);
      });
  }

  fetchZaverecnePraceData(typ: string) {

    const idOsoba  = this.idOsoba && this.idOsoba > 0 ? '/' + this.idOsoba : '';

    this.http
      .get<ZaverecnaPraca[]>('/ais/rest/apps/vsk/zaverecne-prace' +
      '/' + typ + idOsoba)
      .subscribe(data => {
        this.zaverecnePraceDataFetched.next(data);
      });
  }

  kopirujPolozkyZoStudProgramu(idStudProgramFrom: number,
    kodyJazykov: string[]) {

      // console.log('kopirujem polozky');

    this.http
      .get<number>('/ais/rest/apps/vsk/vytvorKopiuFormulara' +
      '/' + this.idTypDokumentu +
      '/' + idStudProgramFrom +
      '/' + this.idStudProgram +
      '/' + kodyJazykov.join('-'))
      .subscribe(data => {
        // console.log('skoncil som kopirovanie poloziek');
        this.pocetSkopirovanychPoloziekDataFetched.next(data);
      });

  }

  kopirujPolozkyZPodprogramu(idPodprogramFrom: number,
    kodyJazykov: string[]) {

      // console.log('kopirujem polozky');

    this.http
      .get<number>('/ais/rest/apps/vsk/vytvorKopiuFormularaPodprogramu' +
      '/' + this.idTypDokumentu +
      '/' + idPodprogramFrom +
      '/' + this.idPodprogram +
      '/' + kodyJazykov.join('-'))
      .subscribe(data => {
        // console.log('skoncil som kopirovanie poloziek');
        this.pocetSkopirovanychPoloziekDataFetched.next(data);
      });

  }

  fetchStupneStudiaData() {
    this.http
      .get<string[]>('/ais/rest/apps/vsk/stupneStudia')
      .subscribe(data => {
        this.stupneStudiaDataFetched.next(data);
      });
  }

  fetchTypyStudiaData() {
    this.http
      .get<string[]>('/ais/rest/apps/vsk/typyStudia')
      .subscribe(data => {
        this.typyStudiaDataFetched.next(data);
      });
  }


  fetchZabezpecovanePredmety(typ: string, akRok: string) {

    const akRokText = akRok && akRok.length > 0 ? '/' + akRok.replace('/', '-') : '';
    const idOsoba  = this.idOsoba && this.idOsoba > 0 ? '/' + this.idOsoba : '';

    const url = '/ais/rest/apps/vsk/zabezpecovane-predmety' + '/' + typ + akRokText + idOsoba;
    this.http
      .get<Predmet[]>(url)
      .subscribe(data => {
        this.zabezpecovanePredmetyFetched.next(data);
        // this.fetchAktualnyAkademickyRok();
      });
  }



  fetchAkademickeRoky() {
    this.http
      .get<string[]>('/ais/rest/apps/vsk/akademickeRoky')
      .subscribe(data => {
        this.akademickeRokyFetched.next(data);
        // this.fetchAktualnyAkademickyRok();
      });
  }

  fetchAktualnyAkademickyRok() {
    this.http
      .get<string>('/ais/rest/apps/rozvrh/aktualnyAkRok')
      .subscribe(data => {
          this.aktualnyAkRokFetched.next(data);
      });
  }

}
